module.exports = __webpack_public_path__ + "static/media/editDetails.894ea9d9.svg";